/* eslint-disable react/no-unknown-property */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ImageUrl } from '../../../utils/constants';
import { GetInitiativeLibrary } from '../../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { fetchApi } from '../../../utils/methods';
import SkeletonLoder from '../../common/skeletonLoder';
import { InitiativesWrap, InitiativeCard } from '../../HealthDataManagement/styles';
import { RecognitionEyeIconNew, RecognitionLaunchIcon } from '../../../utils/icons';
import DetailPopup from '../../HealthDataManagement/initiativesInfo';
import { Heading } from '../../WellnessAdmin/style';
import { AdminCategoriesNew } from '../../../utils/icons';
import { NoData } from '../../EngagementSectionV2/styles';
import { BrandingTabContainer, BrandingTab } from '../../common/commonStyles';

class InitiativeLibraryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      libraryInitiatives: [],
      showDetailPopup: false,
      detailInitiative: null,
    };
  }

  componentDidMount() {
    this.getLibraryInitiatives();
  }

  getLibraryInitiatives = async () => {
    this.setState({ loading: true });
    const companyId = this.props.companyInfo?.id;
    try {
      const res = await fetchApi(`${GetInitiativeLibrary}/${companyId}`, 'GET');
      if (res.status === 'success') {
        this.setState({ libraryInitiatives: res?.data, loading: false });
      } else {
        toast.error(res.error);
        this.setState({ loading: false });
      }
    } catch (error) {
      window.console.error(error);
      this.setState({ loading: false });
    }
  };

  redirectToLaunch = (initiative) => {
    this.props.history.push({
      pathname: '/company/company-initiative',
      state: { id: initiative?.id, initiative_name: initiative?.initiative_name, initiativeDetails: initiative },
    });
  };

  render() {
    const { loading, libraryInitiatives, showDetailPopup, detailInitiative } = this.state;
    const getColor = 'rgba(243, 122, 101, 1)';

    return (
      <div style={{ width: '1248px', margin: 'auto', padding: '25px 0' }}>
        {/* Back tab header — same pattern as other admin pages */}
        <BrandingTabContainer marginBottom="25px" marginRight="0px">
          <BrandingTab
            width padding
            active={true}
            background={getColor}
            onClick={() => this.props.history.push({ pathname: '/company/health', state: 'library' })}
          >
            Library
          </BrandingTab>
        </BrandingTabContainer>

        <Heading>
          <div className="icon" style={{ marginRight: '4px' }}>{AdminCategoriesNew('#184A61')}</div>
          Initiative Library
        </Heading>

        {loading ? (
          <SkeletonLoder width="1248px" height="500px" />
        ) : !libraryInitiatives?.length ? (
          <NoData>No Data Found!</NoData>
        ) : (
          <InitiativesWrap>
            <div className="details">
              {/* Render all initiatives in a 3-column grid — same InitiativeCard used in library.js */}
              {Array.from({ length: Math.ceil(libraryInitiatives.length / 3) }, (_, rowIndex) => (
                <React.Fragment key={rowIndex}>
                  <div className="initiative-row">
                    {libraryInitiatives.slice(rowIndex * 3, rowIndex * 3 + 3).map((initiative) => (
                      <div className="initiative-card" key={initiative.id}>
                        <InitiativeCard background={initiative?.color}>
                          <div className="icon">
                            <img src={`${ImageUrl}/${initiative?.initiative_white_icon}`} alt="initiative" />
                          </div>
                          <div className="initiative-title">{initiative.initiative_name}</div>
                          <div
                            className="end-container"
                            onClick={() =>
                              initiative?.re_launch_status
                                ? this.redirectToLaunch(initiative)
                                : this.setState({ showDetailPopup: true, detailInitiative: initiative })
                            }
                          >
                            {initiative?.re_launch_status ? RecognitionLaunchIcon() : RecognitionEyeIconNew()}
                          </div>
                        </InitiativeCard>
                      </div>
                    ))}
                  </div>
                  {rowIndex + 1 !== Math.ceil(libraryInitiatives.length / 3) && (
                    <div className="border-card" />
                  )}
                </React.Fragment>
              ))}
            </div>
          </InitiativesWrap>
        )}

        {showDetailPopup && (
          <DetailPopup
            showModal={showDetailPopup}
            detailInitiative={detailInitiative}
            onClose={() => this.setState({ showDetailPopup: false, detailInitiative: null })}
            companyId={this.props.companyInfo?.id}
          />
        )}
      </div>
    );
  }
}

InitiativeLibraryPage.propTypes = {
  history: PropTypes.object,
  companyInfo: PropTypes.object,
};

export default connect(null, null)(InitiativeLibraryPage);
